import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 8px;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

const Radio = styled.input`
  // Remove browser styles
  appearance: none;
  background-color: #fff;
  margin: 0;

  // Add custom styles
  font: inherit;
  color: currentColor;
  width: 20px;
  height: 20px;
  border: 2px solid currentColor;
  border-radius: 50%;

  &::before {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    margin: 3px 0 0 3px;
    background-color: $ds-primary-blue;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
  }

  &:checked {
    border-color: $ds-primary-blue;
  }

  &:checked::before {
    transform: scale(1);
  }
`;

const ReportText = styled.a`
  cursor: pointer;
  color: $ds-primary-blue-active;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

type Reason = {
  id: number;
  name: string;
};

type Props = {
  reasonId?: number;
  reasons: Reason[];
  onChange: (id: number) => void;
  onReport: () => void;
};

export const ContentFeedback: React.FC<Props> = ({
  reasonId,
  reasons,
  onChange,
  onReport,
}) => {
  return (
    <Container>
      <Heading size="sm">
        We'll show you less content like this. Was there something in particular
        you didn't like?
      </Heading>

      <OptionContainer>
        {reasons.map((reason) => (
          <Option key={reason.id} onClick={() => onChange(reason.id)}>
            <Radio
              type="radio"
              checked={reasonId === reason.id}
              onChange={() => onChange(reason.id)}
            />
            <Body>{reason.name}</Body>
          </Option>
        ))}
      </OptionContainer>

      <Body>
        If you think there is a problem with this content,{' '}
        <ReportText onClick={onReport}>report this post</ReportText>.
      </Body>
    </Container>
  );
};
